import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import nodesService from '@/diagrams/services/nodes-service'
import CreateNodeEvent from '@/diagrams/events/create-node-event'
import Action from '@/diagrams/models/action'
import ActionGroup from '@/diagrams/models/action-group'
import Node from '@/diagrams/models/node'
import NodeEntity from '@/common/models/node-entitiy'
import moment from 'moment'
import { KeywordType } from '@/diagrams/models/keyword-type'
import EditNodeEvent from '@/diagrams/events/edit-node-event'
import Guid from '@/app/utils/guid'
import Project from '@/projects/entities/project'

@Component
export default class EditAction extends Vue {

  @Prop({ default: null })
  private parentId!: null | string

  @Prop({ default: false })
  private editMode!: boolean

  @Prop({ default: false })
  private archived!: boolean

  @Ref()
  private validator!: ValidationObserver

  private createNodeEvent!: CreateNodeEvent
  private debounceWait = 1000
  private loading = false
  private showCreateEntityButton = false
  private model: Action = new Action()
  private groups: ActionGroup[] | null = null

  @Watch('model', { deep: true })
  private modelChanged() {
    if (moment(this.model.end).diff(this.model.begin, 'days') < 0) {
      this.model.end = this.model.begin
    }
  }

  get keywordType() {
    return KeywordType.Action
  }

  private createNewEntity() {
    this.createNodeEvent = new CreateNodeEvent(new Project(), new Node(), 'Action')
    this.$bus.$emit('node:create', this.createNodeEvent)
    this.$bus.$emit('reload-spider')
  }

  private createNode(evt: CreateNodeEvent) {
    this.showCreateEntityButton = false
    if (evt && evt.className === "Action") {
      this.model = new Action()
      if (evt.parent.dbId !== Guid.empty()) {
        this.model.groups = [evt.parent.dbId]
      }
      this.reset()
    }
  }

  private async editNodeAsync(evt: EditNodeEvent) {
    this.createNodeEvent = new CreateNodeEvent(evt.project, evt.node, "Action")
    this.showCreateEntityButton = true
    if (evt.node && evt.node.className === "Action") {
      this.loading = true
      const res = await nodesService.findOneAsync<Action>("Action", evt.node.dbId)
      if (res) {
        this.model = res
      }
      this.loading = false
      this.reset()
    }
  }

  private async saveAsync() {
    if (await this.validator.validate() && this.model.groups && this.model.groups.length >= 1) {
      this.$bus.$emit('db:state', 'saving')
      this.model = await nodesService.saveAsync("Action", this.model)
      this.$bus.$emit('db:state', 'persisted')
      this.$bus.$emit('reload-spider')
    }
  }

  private async selectAndSaveAsync(selected: NodeEntity) {
    this.model.name = selected.name
    if (selected.keywords) {
      this.model.keywords = selected.keywords
    }
    await this.saveAsync()
  }

  private reset() {
    if (this.validator) {
      this.validator.reset()
    }
  }

  private async created() {
    this.$bus.$on('node:create', this.createNode)
    this.$bus.$on('node:edit', this.editNodeAsync)
  }
}
